import { useQuery } from '@tanstack/react-query';
import {
  getGoalStatusSummaryData,
  getTeamsTableGraphql,
  getTeamComparisonData,
} from './query';
export const QUERY_KEYS = {
  goalsMetric: 'goalsMetric',
  goalsData: 'goalsData',
  contributorList: 'contributorList',
  goalStatusSummary: 'goalStatusSummary',
  goalsTeamTableData: 'goalsTeamTableData',
  contributors: 'contributors',
  teamComparison: 'teamComparison',
};

export const useTeamsTableGql = (
  teamId: string,
  teams: string[],
  currentPage: number
) => {
  return useQuery(
    [QUERY_KEYS.goalsTeamTableData, currentPage, teamId, teams],
    () => getTeamsTableGraphql(currentPage, teamId, teams),
    {
      select: (data) => data?.TeamDtoWithHierarchy,
    }
  );
};
export const useTeamComparisonGql = (
  startDate: string,
  endDate: string,
  sprintId: string,
  teamId: string,
  teams: string[],
  metric: string,
  isPerMemberMetric: boolean,
  orderBy: string,
  pageNumber: number
) => {
  return useQuery(
    [
      QUERY_KEYS.teamComparison,
      startDate,
      endDate,
      sprintId,
      teamId,
      teams,
      metric,
      isPerMemberMetric,
      orderBy,
      pageNumber,
    ],
    () =>
      getTeamComparisonData(
        startDate,
        endDate,
        sprintId,
        teamId,
        teams,
        metric,
        isPerMemberMetric,
        orderBy,
        pageNumber
      ),
    {
      select: (data) => data?.TeamComparisonData,
      enabled: !!startDate && !!endDate && (orderBy ? true : teams.length > 0),
    }
  );
};

export const useGoalStatusSummaryGql = (
  goalScope: string,
  associatedIds: string[]
) => {
  return useQuery(
    [QUERY_KEYS.goalStatusSummary, goalScope, associatedIds],
    () => getGoalStatusSummaryData(goalScope, associatedIds),
    {
      select: (data) => data.GoalStatusSummaryData,
      enabled: !!associatedIds && associatedIds.length > 0,
    }
  );
};
